<template>
  <div>
    <el-upload
      :http-request="uploadHandle"
      :limit="limit"
      action=""
      :show-file-list="false"
      :multiple="true"
      :before-upload="beforeUpload"
      ref="uploader"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <span slot="tip" class="el-upload__tip"> {{ uploadTip }} </span>
    </el-upload>

    <div class="file-list">
      <div v-for="(file, index) in fileList" :key="index" class="file-item">
        <span>
          <i class="el-icon-document"></i>
          {{ file.name }}
        </span>
        <i
          v-if="file.status === 'success' || !file.status"
          :class="hoveredFile === file ? 'el-icon-delete delete' : 'el-icon-success success'"
          @click="clearByIndex(index)"
          @mouseenter="hoveredFile = file"
          @mouseleave="hoveredFile = null"
        ></i>
        <i v-if="file.status === 'uploading'" class="el-icon-loading uploading"></i>
        <i v-if="file.status === 'error'" class="el-icon-error error"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { Toolkit, OssUtil } from "@/util";
export default {
  components: {},
  props: {
    onUploadSuccess: Function,
    value: Array,
    bucket: {
      type: String,
      default: "yxmgt-private"
    },
    uploadTip: {
      type: String,
      default: "支持单个或多个文件上传，单个文件大小不超过20MB"
    },
    filePath: {
      type: String,
      default: "/driver/contract"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 3
    },
    simpleData: {
      type: Boolean,
      default: false
    },
    beforeUpload: {
      type: Function,
      default: () => true
    }
  },
  watch: {
    value: {
      handler(val = []) {
        if (val.length > 0) {
          if (val[0] instanceof Object) {
            this.fileList = [...val];
          } else {
            this.fileList = val.map((t) => ({
              name: Toolkit.getFileNameFromUrl(t),
              url: t,
              status: "success",
              uid: t
            }));
          }
        } else {
          this.fileList = [];
        }
      },
      immediate: true
    }
  },
  computed: {},
  data() {
    return {
      stsCredentials: "",
      fileList: [],
      hoveredFile: null
    };
  },
  methods: {
    async clearByIndex(index) {
      const values = this.fileList.filter((t, i) => i !== index);

      if (this.simpleData) {
        this.$emit(
          "input",
          values.map((t) => t.url)
        );
      } else {
        this.$emit("input", values);
      }
      // const client = await this.getOssClient();
      // const path = `${this.filePath}/${FileUtil.getFileName(file.url)}`;
      // client.delete(path);
    },

    async uploadHandle(option) {
      this.uploading = true;
      const client = await OssUtil.getOssClient(this.bucket);
      const dotIndex = option.file.name.lastIndexOf(".");
      const fileType = option.file.name.substr(dotIndex);
      const fullName = `${this.filePath}/${Toolkit.uuid()}${fileType}`;

      let file = {
        name: option.file.name,
        url: null,
        size: option.file.size,
        status: "uploading",
        uid: option.file.uid
      };
      this.fileList.push(file);

      client
        .put(fullName, option.file)
        .then((res) => {
          this.uploading = false;
          const index = this.fileList.findIndex((t) => t.uid === file.uid);
          // console.table(this.fileList);
          this.fileList[index] = { ...file, url: res.url, status: "success" };
          const values = this.simpleData ? this.fileList.map((t) => t.url) : [...this.fileList];
          this.$emit("input", values);
          if (this.onUploadSuccess) {
            this.onUploadSuccess(values);
          }
        })
        .catch((err) => {
          this.uploading = false;
          console.error(err);
          this.$message.error("上传失败");
        });
    }
  }
};
</script>
<style lang="less" scoped>
.file-list {
  position: relative;
  min-height: 60px;
  padding-top: 10px;
  .file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: 30px;

    .success {
      color: rgb(103, 194, 58);
      font-size: 20px;
      cursor: pointer;
    }

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
